import React, { useState, useEffect } from 'react';
import { X, User } from 'lucide-react';
import request from '../../utils/request';
import '../Modal/Modal.scss';
import './EditNameModal.scss';

function EditNameModal({ visible, currentName, onSuccess, onCancel }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (visible) { setName(currentName || ''); setError(''); }
  }, [visible, currentName]);

  if (!visible) return null;

  const handleSubmit = async () => {
    if (!name.trim()) { setError('请输入名称'); return; }
    if (name.trim().length > 50) { setError('名称不能超过50个字符'); return; }
    setLoading(true); setError('');
    try {
      await request.post('/auth/updateChannelName', { channelName: name.trim() });
      // 更新本地存储
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      userInfo.channel_name = name.trim();
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      onSuccess(name.trim());
    } catch (err) {
      setError(err.message || '保存失败');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420 }}>
        <div className="modal-header">
          <div className="modal-header-left">
            <div className="modal-header-icon"><User size={20} /></div>
            <div className="modal-header-text">
              <h3 className="modal-header-title">修改名称</h3>
              <p className="modal-header-desc">设置您的渠道显示名称</p>
            </div>
          </div>
          <button className="modal-close" onClick={onCancel}><X size={20} /></button>
        </div>
        <div className="modal-body">
          <div className="edit-name-field">
            <label className="edit-name-label">名称</label>
            <input className="edit-name-input" type="text" placeholder="请输入名称" maxLength={50} value={name} onChange={e => { setName(e.target.value); setError(''); }} />
            {error && <div className="edit-name-error">{error}</div>}
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-footer-btn cancel" onClick={onCancel}>取消</button>
          <button className="modal-footer-btn confirm" onClick={handleSubmit} disabled={loading}>{loading ? '保存中...' : '保存'}</button>
        </div>
      </div>
    </div>
  );
}

export default EditNameModal;
